export const randomString = (length, base = 10) => Math
  .floor(Math.random() * Math.pow(base, length))
  .toString(base)
  .padStart(length, "0")
  .toUpperCase();

export const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};